import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AlertRule, AlertSummary } from './api.models';
import { ApiService } from './api.service';

export const ALERT_RULE_LABELS: Record<AlertRule, string> = {
  Rejected: 'Factures rejetées',
  DeliveryFailed: 'Échecs',
  Stuck: 'Factures bloquées',
};

export const ALERT_RULE_ICONS: Record<AlertRule, string> = {
  Rejected: 'cancel',
  DeliveryFailed: 'report',
  Stuck: 'hourglass_top',
};

/** Compteurs d'alertes de l'utilisateur, rafraîchis périodiquement (badge de navigation, bandeau). */
@Injectable({ providedIn: 'root' })
export class AlertsService {
  private readonly api = inject(ApiService);
  private readonly _summary = signal<AlertSummary | null>(null);
  private timer: ReturnType<typeof setInterval> | null = null;

  readonly summary = this._summary.asReadonly();

  /** Démarre le rafraîchissement (toutes les 60 s). */
  start(): void {
    if (this.timer) return;
    this.refresh();
    this.timer = setInterval(() => this.refresh(), 60_000);
  }

  refresh(): void {
    this.api
      .alertSummary()
      .subscribe({ next: (s) => this._summary.set(s), error: () => undefined });
  }

  markRead(request: { ids?: number[]; rule?: AlertRule | null }): Observable<{ marked: number }> {
    return this.api.markAlertsRead(request).pipe(tap(() => this.refresh()));
  }
}
